import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Flickity from 'flickity';
import 'flickity/css/flickity.css';

const flickityOpts = {
  cellAlign: 'left',
  contain: true,
  wrapAround: true,
  initialIndex: 1, // TODO figure out why acts funny on zero
  pageDots: false,
  autoPlay: 5000, // Default is 3 seconds
};

const FlickityWidget = ({ children }) => {
  const carouselRef = useRef();

  useEffect(() => {
    const flickity = new Flickity(carouselRef.current, flickityOpts);
    return () => flickity.destroy();
  }, []);

  return (
    <div className="carousel" ref={carouselRef}>
      {children}
    </div>
  );
};

FlickityWidget.propTypes = {
  children: PropTypes.any,
};

export default FlickityWidget;
